<template>
  <button
    class="flex cursor-pointer items-stretch rounded-lg text-left outline-offset-[-2px]"
    :class="{
      'bg-[#384C66]': selected,
      [backgroundColorToTailwindMap[backgroundColor!]]: backgroundColor !== undefined && !selected,
      'bg-grey-25': backgroundColor === undefined && !selected,
    }"
  >
    <div
      class="min-w-2 rounded-l-lg"
      :class="{
        [leadingColorToTailwindMap[leadingColor!]]: !!leadingColor,
      }"
    />

    <div class="flex flex-1 justify-between gap-4 px-2 py-[10px] xs:px-4">
      <div class="flex items-center gap-4">
        <img aria-hidden="true" class="size-10" :src="props.icon" alt="" />
        <div class="flex flex-1 flex-col text-left">
          <h2 class="text-base font-medium text-type-primary xs:text-xl" :class="{ 'text-white': selected }">{{ title }}</h2>
          <div class="text-xs text-type-secondary xs:text-base" :class="{ 'text-white': selected }">
            <p v-html="useSanitiseHtml(description)" />
          </div>
        </div>
      </div>
      <div class="flex flex-col items-end justify-between text-type-secondary">
        <div class="w-max text-end text-xs xs:text-base xl:text-nowrap" :class="{ 'text-white': selected }">
          <ui-relative-time :time="publishedAt" :time-text="publishedAtText" :relative-date-time-format="relativeDateTimeFormat" />
        </div>
        <gv-icon name="info" class="size-6" :class="{ 'fill-white': selected }" />
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import { useSanitiseHtml } from '@/common';
import { RelativeDateTimeFormat, UiListTileBackgroundColor, UiListTileLeadingColor } from '@/features/hazards';

const props = defineProps<{
  leadingColor?: UiListTileLeadingColor;
  backgroundColor?: UiListTileBackgroundColor;
  title?: string;
  description?: string;
  publishedAt?: string;
  publishedAtText?: string;
  relativeDateTimeFormat?: RelativeDateTimeFormat;
  icon?: string;
  selected: boolean;
}>();

const leadingColorToTailwindMap = {
  [UiListTileLeadingColor.Black]: 'bg-black',
  [UiListTileLeadingColor.Gray]: 'bg-gray',
  [UiListTileLeadingColor.Blue]: 'bg-blue',
  [UiListTileLeadingColor.Yellow]: 'bg-yellow',
  [UiListTileLeadingColor.Orange]: 'bg-orange',
  [UiListTileLeadingColor.Red]: 'bg-red',
};

const backgroundColorToTailwindMap = {
  [UiListTileBackgroundColor.Pink]: 'bg-pink-50',
  [UiListTileBackgroundColor.Orange]: 'bg-orange-50',
};
</script>
